import * as React from "react";

interface INaarWaarheidIngevuldContextProviderProps {
  children: React.ReactNode;
}

export interface INaarWaarheidIngevuldContext {
  naarWaarheidIngevuld: boolean;
  setNaarWaarheidIngevuld: React.Dispatch<React.SetStateAction<boolean>>;
  foutmelding: string | undefined;
  setFoutmelding: React.Dispatch<React.SetStateAction<string | undefined>>;
}

export const NaarWaarheidIngevuldContext = React.createContext<INaarWaarheidIngevuldContext>({
  naarWaarheidIngevuld: false,
  setNaarWaarheidIngevuld: () => {
    console.error("Component not wrapped in NaarWaarheidIngevuldContextProvider");
  },
  foutmelding: undefined,
  setFoutmelding: () => {
    console.error("Component not wrapped in NaarWaarheidIngevuldContextProvider");
  }
});

export const useNaarWaarheidIngevuldContext = () => React.useContext(NaarWaarheidIngevuldContext);

export const NaarWaarheidIngevuldContextProvider = (props: INaarWaarheidIngevuldContextProviderProps) => {
  const [naarWaarheidIngevuld, setNaarWaarheidIngevuld] = React.useState(false);
  const [foutmelding, setFoutmelding] = React.useState<string | undefined>(undefined);

  return (
    <NaarWaarheidIngevuldContext.Provider
      value={{ naarWaarheidIngevuld, setNaarWaarheidIngevuld, foutmelding, setFoutmelding }}
    >
      {props.children}
    </NaarWaarheidIngevuldContext.Provider>
  );
};
